import { RiskClassification } from "@/@types/sintegrada/RiskClassification";
import { getSintegradaServerApi } from "@/services/api";

type GrievanceNotificationParams = {
	uf: string;
	ibgeCode: string;
	cnes?: string;
};

export async function getRiskClassifications({
	uf,
	ibgeCode,
	...params
}: GrievanceNotificationParams) {
	const response = await getSintegradaServerApi().get<RiskClassification[]>(
		`/RiskClassification/risk-classifications`,
		{ ibgeCode, ...params }
	);
	return response.data || [];
}
